import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { localRead } from '@/libs/util'
import customZhCn from './lang/zh-CN'
// import customZhTw from './lang/zh-TW'
import customEnUs from './lang/en-US'
import zhCnLocale from 'iview/src/locale/lang/zh-CN'
import enUsLocale from 'iview/src/locale/lang/en-US'
// import zhTwLocale from 'iview/src/locale/lang/zh-TW'

Vue.use(VueI18n)

// console.log('customEnUs',customEnUs)

// 自动根据浏览器系统语言设置语言
const navLang = navigator.language

let localLang1 = (navLang === 'zh-CN' || navLang === 'en-US' || navLang === 'en' || navLang === 'zh') ? navLang : false
let langObj = {'en':'en-US','en-US':'en-US','zh':'zh-CN','zh-CN':'zh-CN'}
let localLang = langObj[localLang1]

// console.log('localLang',localLang)
// console.log('localLang1',localLang1)

let lang = 'en-US'
// let store = JSON.parse(sessionStorage.getItem("store"))

// if(store && store.langSet){
//   lang = localRead('local') || localLang || 'en-US'
// }else{
//   lang = localLang || localRead('local') || 'en-US'
// }
lang = localRead('local') || localLang || 'en-US'


// console.log('let lang ',localRead('local'))
// console.log(' localLang  ', localLang)
// console.log('store ',store)
// console.log('  lang ',  lang )
// lang = localRead('local') || localLang || 'en-US'

// console.log('lang',navLang)

Vue.config.lang = lang

// vue-i18n 6.x+写法
Vue.locale = () => {}
const messages = {
  'zh-CN': Object.assign(zhCnLocale, customZhCn),
  // 'zh-TW': Object.assign(zhTwLocale, customZhTw),
  'en-US': Object.assign(enUsLocale, customEnUs)
}
const i18n = new VueI18n({
  locale: lang,
  messages
})

export default i18n

// vue-i18n 5.x写法
// Vue.locale('zh-CN', Object.assign(zhCnLocale, customZhCn))
// Vue.locale('en-US', Object.assign(zhTwLocale, customZhTw))
// Vue.locale('zh-TW', Object.assign(enUsLocale, customEnUs))
